import React from 'react';
import { arrayOf, func, oneOfType, string } from 'prop-types';
import { Col, DatePicker } from 'antd';
import moment from 'moment';
import 'moment/locale/el';
import { formatTitle } from './utils';
import styles from './styles';

const dateFormat = 'DD-MM-YYYY';

const DateFilter = ({
  defaultValue,
  name,
  onSetFilter,
  placeholder,
  title,
}) => {
  const handleChange = React.useCallback(
    (date, dateString) => onSetFilter(name, dateString),
    [name, onSetFilter]
  );

  return (
    <Col xxl={6} xl={8} lg={12} xs={24} style={styles.filter}>
      <span className="grid-filter-label" style={styles.ellipsis}>
        {formatTitle(title)}
      </span>
      <DatePicker
        placeholder={formatTitle(placeholder)}
        format={dateFormat}
        style={styles.filterInput}
        onChange={handleChange}
        defaultValue={
          (defaultValue, value => (value ? moment(value, dateFormat) : null))
        }
      />
    </Col>
  );
};

DateFilter.propTypes = {
  defaultValue: string,
  name: string,
  onSetFilter: func,
  placeholder: oneOfType([string, arrayOf(string)]),
  title: oneOfType([string, arrayOf(string)]),
};

export default DateFilter;
